module.exports = __webpack_public_path__ + "img/bag_2.822bd41c.svg";